const navs = [
    {name: "labels.programing", url: "/route-management/programing/", icon: "clipboard", role: "admin"},
    {name: "labels.areas", url: "/route-management/areas/", icon: "layer-group", role: "admin"},
    {name: "labels.waypoints", url: "/route-management/waypoints/", icon: "map-location-dot", role: "admin"},
    {name: "labels.routes-dynamic", url: "/route-management/routes-dynamic/", icon: "route", role: "tech"},
    {name: "labels.routes-static", url: "/route-management/routes-static/", icon: "location-dot", role: "tech"},
    {name: "labels.routes-fly", url: "/route-management/routes-fly/", icon: "sack-xmark", role: "tech"},
    {name: "labels.calendar", url: "/route-management/calendar/", icon: "calendar-days", role: "tech"},
];

export default navs;
